module.exports = __webpack_public_path__ + "img/knsu_thumbnail.120f1fce.jpg";